<template>
    <div class="col-lg-9 c-content-main">
        <personal-info></personal-info>
        <company-info v-if="$store.state.user.role === 'owner'"></company-info>
    </div>
</template>

<script>
    import PersonalInfo from "./PersonalInfo";
    import CompanyInfo from "./CompanyInfo";

    export default {
        components: {CompanyInfo, PersonalInfo},
    }
</script>